<app-azara-wrapper>
    <section>
        <h2 class="font-weight-bold text-center">Unauthorized Access</h2>
        <div class="mb-1">Please request access to this page from your system administrator or contact</div>
        <div class="mb-6">
            <a class="link pt-1" href="mailto:support@azarahealthcare.com">support&#64;azarahealthcare.com</a>
            for more information
        </div>
        <div>
            <a
                class="link cursor-pointer"
                tabindex="0"
                (click)="handleSignoutClicked()"
                (keyup.enter)="handleSignoutClicked()"
            >
                Click here
            </a>
            to sign out
        </div>
    </section>
</app-azara-wrapper>
